import petsTelevetPlus from '../../ru/pets-televet-plus/pets-televet-plus.dic.json';

export const petsTelevetPlusNS = {
  PETS_TELEVET_PLUS: petsTelevetPlus,
};

export const petsTelevetPlusNamespaces = ['PETS_TELEVET_PLUS'];
